import de from './de.json';
import en from './en.json';

const messages = { de, en };

export default { messages, invariant: 'de' };



// WEBPACK FOOTER //
// ./src/app/@remax-de/locales/index.js